import * as React from 'react'

import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~/client/src/shared/components/shadcn-ui/dialog'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import MaterialsUploadStore from '../MaterialsUpload.store'

// localization: translated

interface IProps {
  store: MaterialsUploadStore
  titleRenderer(title: string): JSX.Element
}

@observer
export default class MaterialsUploadConfirmDialog extends React.Component<IProps> {
  public render() {
    const { store, titleRenderer } = this.props
    const {
      isUploadConfirmDialogShown,
      resetInitialValues,
      uploadMergeMaterialsExcel,
      openReplaceDataDialog,
    } = store

    return (
      <Dialog open={isUploadConfirmDialogShown}>
        <DialogContent showCloseButton={false}>
          <DialogHeader>
            <DialogTitle render={<div />}>
              {titleRenderer(
                Localization.translator.materialsUploadConfirm.confirmDataMerge,
              )}
            </DialogTitle>
          </DialogHeader>
          <div className="relative">
            <div className="text large light">
              {
                Localization.translator.materialsUploadConfirm
                  .confirmDescription1
              }
              <br />
              <br />
              {
                Localization.translator.materialsUploadConfirm
                  .confirmDescription2
              }
              <span
                className="ml5 no-grow nowrap underline-hover text large blue-highlight pointer"
                onClick={openReplaceDataDialog}
              >
                {
                  Localization.translator.materialsUploadConfirm
                    .confirmDescription3
                }
              </span>
            </div>
          </div>

          <DialogFooter>
            <Button
              variant="outline"
              className="tw:grow"
              onClick={resetInitialValues}
            >
              {Localization.translator.cancel}
            </Button>
            <Button
              variant="default"
              className="tw:grow"
              onClick={uploadMergeMaterialsExcel}
            >
              {Localization.translator.upload_noun}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    )
  }
}
